<template>
  <el-col id="day-date" :span="5">
    <p class="route_tble__dayInfo">
      <span class="day-info-block">
        <span v-if="day.status === 1" class="day-status"> (День закрыт) </span>
        <span v-if="day.total_report_created_at" class="day-report">
          (Отчет сдан)
        </span>
      </span>
      Погрузка {{ day.load_date | getHumanDate }}
    </p>
    <p class="rt-dayInfo">
      cоздан {{ getDateOfCertainFormat(day.created_at) }}
    </p>
  </el-col>
</template>

<script>
export default {
  name: 'DayDate',
  props: {
    day: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
#day-date
  p
    display: flex
    align-items: center
    justify-content: center
  .route_tble__dayInfo
    font-weight: normal
    line-height: 10px
    display: flex
    justify-content: flex-start
    align-items: flex-start
    flex-direction: column
    margin-top: 0
    .day-info-block
      margin-bottom: 10px
      font-size: 13px
      .day-status
        color: #F10000
      .day-report
        color: #67C23A
      span + span
        margin-left: 5px
</style>
